


















import {computed, defineComponent, PropType, ref} from "@vue/composition-api";
import {DefinedBillingPlan} from "../billing.types";

export default defineComponent({
    props: {
        value: {
            type: Number,
            required: true
        },
        plans: {
            type: Array as PropType<DefinedBillingPlan[]>,
            required: true
        },
        teamProjectsCount: {
            type: Number,
            default: 1
        },
        currentPlanQuantity: {
            type: Number,
            required: false
        },
    },
    setup(props, {emit}) {
        const localValue = computed<number>({
            get() {
                return props.value;
            },
            set(newValue: number) {
                emit('update:value', newValue);
            }
        });

        const requiredCustomQuote = ref(false)

        const availablePlansQuantities = props.plans.filter(plan => plan.quantity !== props.currentPlanQuantity).map(plan => plan.quantity);

        const firstAvailablePlanQuantity = availablePlansQuantities.find(plan => plan >= props.teamProjectsCount && plan > (props.currentPlanQuantity ?? 0));

        if (!firstAvailablePlanQuantity) {
            requiredCustomQuote.value = true;
        } else {
            if (firstAvailablePlanQuantity > localValue.value) {
                emit('update:value', firstAvailablePlanQuantity);
            }
        }

        const openChatWidget = () => {
            (window as any).openChatWidget();
        }

        return {
            requiredCustomQuote,
            localValue,
            availablePlansQuantities,
            openChatWidget,
        }
    }
});
